import { useContext } from "react";
import { ModalSimilars } from "../ModalSimilars/web";
import { useIsAuthModalShowing } from "../../../GlobalHooks/useIsAuthModalShowing";
import { useTheme } from "../../../Styles/ThemeHook";
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context";
import { CheckCircleTwoTone, WhatsAppOutlined } from "@ant-design/icons";
import { Col, Row, Space, Typography } from "antd";
import "./styles.less"

type Props ={
	link: string;
	phone: string;
	loading: boolean;
	visible: boolean;
	property_code?: string;
	owner?: any;
	onCancel: () => void;
	owner_name: string;
	property_id: string | number;
	width?: number;
	onWpClick?: () => void;
	icon?: React.ReactNode
}
export const ModalWpp = (props:Props) => {
	const { theme } = useTheme();
	const { isAuthModalShowing } = useIsAuthModalShowing();
	const { main_domain } = useContext(ConfigStateContext)

	let phones = [];
	if (typeof props.phone != "undefined" && props.phone) phones = props.phone.split(";");

	return (
		<ModalSimilars
			visible={props.visible && !isAuthModalShowing}
			onCancel={props.onCancel}
		>
			<Row
				className={"modal-wpp-content"}
				justify={"center"}
				style={{ textAlign: "center" }}
				gutter={[0, theme.spacing.xsSpacing]}>
				<Col span={24}>
					<CheckCircleTwoTone twoToneColor="#52c41a" style={{ fontSize: "25px" }} />
				</Col>
				<Col span={24}>
					<Typography.Text strong>
						
						{"¡No pierdas tiempo y comunicate ahora!"}
					</Typography.Text>
				</Col>
				<Col span={24}>
					<Typography.Text strong>{props.loading ? "loading" : props.owner_name}</Typography.Text>
				</Col>
				<Col span={24}>
					<Row gutter={theme.spacing.lgSpacing} justify={"center"}>
						{phones.map((phone, i) => (
							<Col key={"phone_" + i}>
								<a href={`https://api.whatsapp.com/send?phone=${phone}&text=Estoy interesado en su inmueble ${props.property_id} que vi por https://${main_domain}/inmueble/${props.property_id}&app_absent=1`} target="_blank" onClick={props.onWpClick}>
									<Space size={theme.spacing.xsSpacing}>
										<WhatsAppOutlined style={{ color: "#00C841" }} />
										<Typography.Text style={{ color: theme.colors.linkColor }}>
											{props.loading ? "loading" : phone}
										</Typography.Text>
									</Space>
								</a>
							</Col>
						))}
					</Row>
				</Col>
			</Row>
		</ModalSimilars>
	);
};
